import { FilterEffects } from './filter.effects';
import { FilterDefinitionEffects } from './filter-definition.effects';

export const effects = [FilterEffects, FilterDefinitionEffects];
